module.exports = __webpack_public_path__ + "img/banner5_en_m.b450cb63.png";